import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

const CommunityLeaders = ({ leaders }) => {
  if (!leaders || leaders.length === 0) return <></>
  return (
    <div className="space-y-12 ">
      <h2 className="text-5xl font-extrabold tracking-tight sm:text-4xl">
        Community <span className="text-community-700">leader{leaders.length > 1 ? 's' : ''}</span>
      </h2>

      <ul className="flex gap-y-12 flex-wrap">
        {leaders.map((leader) => {
          const profilePic = leader.data.Profile_Picture_Url_250
          const name = leader.data.Person_First + ' ' + leader.data.Person_Last
          const company = leader.data.Company && leader.data.Company[0]
          return (
            <li key={leader.id} className="w-xs sm:w-128">
              <div className="space-y-4 sm:grid sm:grid-cols-3 sm:gap-6 sm:space-y-0 lg:gap-8">
                <div className="h-32 w-32">
                  <Link to={'/profile/' + leader.data.Person_Url_Slug}>
                    {/* <GatsbyImage
                          image={profilePic}
                          className="object-cover shadow-lg rounded-full"
                          alt={'Picture of ' + name}
                        /> */}
                    <img
                      src={profilePic}
                      alt={'Picture of ' + name}
                      className="object-cover shadow-lg rounded-full bg-gradient-to-r from-blue-200 to-violet-100"
                    />
                  </Link>
                </div>
                <div className="sm:col-span-2">
                  <div className="space-y-4">
                    <div className="text-lg leading-6 font-medium space-y-1">
                      <Link to={'/profile/' + leader.data.Person_Url_Slug}>
                        <h3>{name}</h3>
                      </Link>
                      <p className="text-indigo-600">{leader.data.Person_Job_Title}</p>
                      {company && <p className="text-indigo-600">{company.data.Company_Name}</p>}
                    </div>
                    <div className="text-sm">
                      <p className="text-gray-500 line-clamp-6">{leader.data.Person_Bio}</p>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

CommunityLeaders.propTypes = {
  leaders: PropTypes.array,
}
export default CommunityLeaders
